import { createTokenHeader } from '../utils/functions/headers';
import {
  TCreditPeriod,
  TGeneralImportResponse,
  TGetCreditPeriodListPayload,
} from '../utils/types';
import { emptySplitApi } from './emptySplitApi';

export const creditPeriodService = emptySplitApi
  .enhanceEndpoints({ addTagTypes: ['list'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getAllCreditPeriods: builder.query<
        { data: TCreditPeriod[]; totalCount: number },
        TGetCreditPeriodListPayload
      >({
        query: (params) => ({
          url: 'credit-periods/list',
          method: 'GET',
          params: {
            page: params.pageNo,
            size: params.pageSize,
          },
        }),
        transformResponse: (
          data: TCreditPeriod[],
          meta: Response
        ) => {
          const totalCount =
            meta.headers.get('X-total-count');
          return {
            data,
            totalCount: Number(totalCount ? totalCount : 0),
          };
        },
        providesTags: ['list'],
      }),
      getCreditPeriodDetails: builder.query<
        TCreditPeriod,
        string
      >({
        query: (id) => ({
          method: 'GET',
          url: `credit-periods/${id}`,
        }),
      }),
      updateCreditPeriod: builder.mutation<
        TCreditPeriod,
        TCreditPeriod
      >({
        query: (data) => {
          return {
            url: 'credit-periods',
            method: 'PUT',
            data,
          };
        },
        invalidatesTags: ['list'],
      }),
      importCreditPeriod: builder.mutation<
        TGeneralImportResponse,
        FormData
      >({
        query: (data) => {
          return {
            url: 'credit-period/import',
            method: 'POST',
            data,
            headers: createTokenHeader(),
          };
        },
        invalidatesTags: ['list'],
      }),
    }),
  });

export const {
  useGetAllCreditPeriodsQuery,
  useGetCreditPeriodDetailsQuery,
  useUpdateCreditPeriodMutation,
  useImportCreditPeriodMutation,
} = creditPeriodService;
